export enum SupplyAcquisitionTypeEnum {
    MPS_BASED_ON_PAGE_PRICE = 1, // MPS - Seitenpreisbasiert
    MPS_BASED_ON_UNIT_COUNT, //MPS - Stückzahlbasiert
    PURCHASE,
    NONE,
}
